export default "__VITE_ASSET__sduODGJX__"